import React from 'react';
import type { User } from '../types/user';
import { getRoleBadgeVariant, getRoleDisplayName } from '../utils/formatting';
import { canDeleteUserFromList } from '../utils/userDeleteGuards';
import { TableRowActions, viewIcon, deleteIcon } from '@tpct/admin-ui';
import { __ } from '@/hub-shared/utils/i18n';
import TableBadge from '../../../hub-shared/components/TableBadge';

type UserRowProps = {
  user: User;
  onEdit: (user: User) => void;
  onDelete: (userId: number) => void;
  currentUser: {
    id: number;
    roles: string[];
  };
  canManageUsers?: boolean;
};

const UserRow = ({ user, onEdit, onDelete, currentUser, canManageUsers = true }: UserRowProps) => {
  const handleDelete = () => {
    if (window.confirm(`${__('Êtes-vous sûr de vouloir supprimer l\'utilisateur')} « ${user.name} » ?`)) {
      onDelete(user.id);
    }
  };

  // Why: write actions follow bootstrap manageUsers (work-perm derived); self row stays viewable.
  const canShowViewAction = user.id === currentUser.id || canManageUsers;
  const canShowWriteActions = canManageUsers;
  const showDelete = canShowWriteActions && canDeleteUserFromList(user, currentUser.id);

  const rowActions = [
    ...(canShowViewAction
      ? [{ key: 'view', label: __('Voir'), icon: viewIcon, onClick: () => onEdit(user) }]
      : []),
    ...(showDelete
      ? [
          {
            key: 'delete',
            label: __('Supprimer'),
            icon: deleteIcon,
            onClick: handleDelete,
            variant: 'delete' as const,
          },
        ]
      : []),
  ];

  return (
    <tr className="users-table__row">
      <td className="users-table__name">
        {user.name}
      </td>
      <td className="users-table__role">
        <TableBadge variant={`role-${getRoleBadgeVariant(user.role)}`}>
          {getRoleDisplayName(user.role)}
        </TableBadge>
      </td>
      <td className="users-table__count">
        {user.company_count ?? 0}
      </td>
      <td className="users-table__actions">
        {rowActions.length > 0 ? (
          <TableRowActions actions={rowActions} overflowLabel={__('Plus d’actions')} />
        ) : (
          <span>-</span>
        )}
      </td>
    </tr>
  );
};

export default UserRow;

